// src/i18n/es/ask.ts
// «Preguntar» — panel lateral abierto desde la barra superior. Preguntas en
// lenguaje natural sobre los hoteles de la persona; las tablas y las fuentes
// las construye la API, y la IA puede cambiar los filtros de la pantalla
// abierta (con «Deshacer»).
export const ask = {
  panel: {
    title: 'Preguntar',
    open: 'Preguntar a Insight',
    close: 'Cerrar',
    intro:
      'Pregunte por sus hoteles como se lo preguntaría a un analista. También puede pedir que la pantalla muestre otro periodo u otros hoteles («dame los datos de octubre»).',
    lookingAt: 'Pantalla abierta: %{screen}',
  },

  composer: {
    label: 'Su pregunta',
    placeholder: 'Escriba su pregunta…',
    send: 'Preguntar',
    tooLong: 'La pregunta no puede superar %{max} caracteres.',
    newConversation: 'Nueva conversación',
  },

  scope: {
    generic: 'Solo se consultan los hoteles a los que usted tiene acceso.',
    count: 'Solo se consulta el hotel al que usted tiene acceso. |||| Solo se consultan los %{smart_count} hoteles a los que usted tiene acceso.',
  },

  suggestions: {
    title: 'Puede empezar por una de estas preguntas',
    filterScreen: 'Muestre en esta pantalla los datos del mes pasado',
    selfService: '¿Cuántos hoteles superaron el 50 % de check-in sin recepción el mes pasado?',
    worstPreCheckin: '¿Qué hoteles tienen el pre-check-in más bajo en los últimos 30 días?',
    evolution: '¿Cómo ha evolucionado el check-in sin recepción respecto al mes anterior?',
    kioskTime: '¿En qué hoteles tarda más el check-in en el kiosco?',
    charged: '¿Cuánto se ha cobrado en autoservicio este mes en cada hotel?',
    frontDesk: '¿Cuántos check-ins hizo recepción la semana pasada según el sistema de reservas?',
  },

  view: {
    applied: 'Pantalla actualizada. %{description}',
    undone: 'Cambio deshecho. %{description}',
    undo: 'Deshacer',
  },

  answer: {
    thinking: 'Consultando los datos de sus hoteles…',
    howCalculated: 'Cómo se ha calculado',
    source: '%{description}: del %{from} al %{to}, %{smart_count} hotel |||| %{description}: del %{from} al %{to}, %{smart_count} hoteles',
    originRoommatik: 'Canales de Roommatik',
    originPms: 'Sistema de reservas del hotel',
    incomplete: 'La respuesta puede estar incompleta: la pregunta necesitaba más consultas de las permitidas. Pruebe a acotarla.',
    disclaimer: 'Respuesta generada automáticamente a partir de los datos de la tabla. Compruebe las cifras importantes en la tabla antes de usarlas.',
  },

  errors: {
    unavailable: 'El asistente no está disponible en este momento. Inténtelo de nuevo en unos minutos.',
    rateLimited: 'Ha hecho muchas preguntas seguidas. Espere un minuto e inténtelo de nuevo.',
    forbidden: 'Su usuario no tiene acceso a esta función.',
    invalid: 'Revise la pregunta e inténtelo de nuevo.',
    generic: 'No se ha podido responder a la pregunta. Inténtelo de nuevo.',
  },
};

export default ask;
